import { UI } from '../../../core/static/js/helpers/UI.js'
import ProductCarousel from './product-hero.js'
import ProductNav from './product-nav.js'
import ProductStories from './product-stories.js'
import ProductDetails from './product-details.js'
import ProductFeatures from './product-features.js'
import ProductSwatchList from './product-swatch-list.js'
import { detectiOSARQuickLook } from '../../../core/static/js/helpers/utils.js'
import SizeGuide from './size-guide.js'

const mainUI = {
  body: document.querySelector("body"),
  productNav: document.querySelector("#productNav"),
  productJumpLink: document.querySelector(".product-nav-wrapper .jump-links-dropdown"),
  productDetails: document.querySelector(".product #details"),
  productDetailsWrapper: document.querySelector(".product .details-wrapper .right-wrapper"),
  productCarousal: document.querySelector(".product-variant product-carousel"),
  swatchNav: document.querySelector("#swatchList")
}

//Swatch Nav Stuff
var showSwatchNav = function () {
  mainUI.swatchNav.classList.remove('out-of-sight');
}
var hideSwatchNav = function () {
  mainUI.swatchNav.classList.add('out-of-sight');
}

// Add click outside handler for swatch nav
document.addEventListener('click', function(event) {
  if (mainUI.swatchNav && !mainUI.swatchNav.contains(event.target) && 
      !event.target.closest('.more-colours')) {
    hideSwatchNav();
  }
});

//Animate Home
const text = document.querySelector("#home text");
const textPath = document.querySelector("#home textPath");
var textOffset = -400;
var letterSpace = -40;
var animTimer = function() {
  setInterval(incrementOffset, 10);
}
var incrementOffset = function () {
  if ( textOffset < 600 ){
    textOffset = textOffset + 1;
    letterSpace = letterSpace + 0.1;
    textPath.setAttribute("startOffset", textOffset);
    text.setAttribute("letter-spacing", letterSpace);
  } else {
    clearInterval(animTimer);
    textOffset = -400;
    letterSpace = -40;
  }
}

var cartMenu = document.querySelector('#cartMenu');
var lazyLoadInstance = null;

var setBlockHeight = function (){
  let viewportH = window.innerHeight;
  let navH = UI.find('header').offsetHeight;
  mainUI.body.style.setProperty('--fs-block-height', viewportH - navH + 'px');
}

var seamlessProductNav = function () { //Seamless Product Nav
  mainUI.productNav.classList.add('inverse');
}
var regularProductNav = function () { //Regular Product Nav
  mainUI.productNav.classList.remove('inverse');
}

var stickProductNav = function () { //Product Navigation behaviour
  if (mainUI.body.classList.contains('product-page') && productNav) {
    let heroSection = UI.find('.product #hero');
    if (!heroSection) {
      heroSection = UI.find('.product #hero');
    }
    var navPos = heroSection.offsetHeight;
    if (window.scrollY > navPos) {
      productNav.classList.add('fixed-block');
    } else {
      productNav.classList.remove('fixed-block');
      productNav.classList.remove('shift');
    }
  }
  if (mainUI.body.classList.contains('product-page') && productNav) {
    let teeFeaturePage = UI.find('.product#tee');
    let unitpqFeaturePage = UI.find('.product#unitpq');
    if (teeFeaturePage) {
      let xPos = UI.find('.product #materials').offsetTop;
      if (window.scrollY > xPos) {
        seamlessProductNav();
      } else {
        regularProductNav();
      }
    }
    if (unitpqFeaturePage) {
      let xPos = UI.find('.product #stories').offsetTop;
      if (window.scrollY > xPos) {
        seamlessProductNav();
      } else {
        regularProductNav();
      }
    }
  }
}

var stickDetailsBlock = function () { //Stick details section till it reaches footer
  if (mainUI.body.classList.contains('product-variant')) {
    let topSpacer = UI.find('#detailsStarter');
    let bottomSpacer = UI.find('#detailsEnder');
    if (bottomSpacer && topSpacer) {
      let windowH = window.innerHeight;
      let yPos = topSpacer.offsetTop;
      let xPos = bottomSpacer.offsetTop - windowH;
      if (window.scrollY < xPos){
        /*  mainUI.productCarousal.classList.add('startpos');*/
          if (window.scrollY > yPos){
            mainUI.productCarousal.classList.add('sticky');
            /*mainUI.productCarousal.classList.remove('startpos');*/
          } else {
            mainUI.productCarousal.classList.remove('sticky');
            mainUI.productCarousal.classList.add('startpos');
          }
        } else {
          mainUI.productCarousal.classList.remove('sticky');
          mainUI.productCarousal.classList.remove('startpos');
        } 
    }
  }
}

var sliderInitialPos = function (){
  window.dispatchEvent(new Event('resize'))
}

var hideScrollIndicator = function () { //Hide Desktop scroll indicator on scrolling
  if (mainUI.body.classList.contains('product-variant')) {
    let slides = document.querySelectorAll(".carousal .carousal-slide");
    let killCarousalClass = document.querySelector(".product-variant .kill-carousal");
    if(slides && window.innerHeight < window.innerWidth && window.innerWidth > 1024){
      if ( window.scrollY > 0 ){
        for (let i = 0; i < slides.length; i++) {
          var slide = slides[i];
          slide.classList.remove('peek');
        }
      }
    }
    if(killCarousalClass){
      for (let i = 0; i < slides.length; i++) {
        var slide = slides[i];
        slide.classList.remove('peek');
      }
    }
  }
}

var toggleProductJumpLink = function () { //Product Jump Links on smaller screens
  if (mainUI.body.classList.contains('product-page') || mainUI.body.classList.contains('product-variant')) {
    if (mainUI.productJumpLink.classList.contains('out-of-sight-y')) {
      productNav.classList.add('opaque');
      regularProductNav();
      mainUI.productJumpLink.classList.remove('out-of-sight-y');
      mainUI.productNav.querySelector('a.section-link').classList.add('selected');
    } else {
      productNav.classList.remove('opaque');
      stickProductNav();
      mainUI.productJumpLink.classList.add('out-of-sight-y');
      mainUI.productNav.querySelector('a.section-link').classList.remove('selected');
    }
  }
}

var jumpToAnchor = function (el, e) { //Smooth scroll #div
  e.preventDefault();
  let productNav = document.querySelector("#productNav");
  let topElem = $(el).attr("href") == '' || $(el).attr("href") == '#' ? '#hero' : $(el).attr("href");
  $("html, body").animate({ scrollTop: $(topElem).offset().top - productNav.offsetHeight }, 800);
}

var resetProductNavLinks = function (el) {
  let nav = document.querySelector('product-nav');
  if (nav) {
    if(typeof(renderPack) !== 'undefined' && renderPack){
      const swatches = document.querySelectorAll(".packswatches .colours-packs .grid a");
      for (let i = 0; i < swatches.length; i++) {
        var swatch = swatches[i];
        swatch.classList.remove('selected');
      }
    }
    else{
      const swatches = document.querySelectorAll(".swatches a");
      for (let i = 0; i < swatches.length; i++) {
        var swatch = swatches[i];
        swatch.classList.remove('selected');
      }
    }


    
  }
  let stories = document.querySelector('product-stories');
  if (stories) {
    const links = document.querySelectorAll(".info a");
    for (let i = 0; i < links.length; i++) {
      var link = links[i];
      link.classList.remove('selected');
    }
  }
}

var setTeeFitLayout = function () { //Todo Need to call on resize too
  let setHeight = UI.find('#tee #fit .shot.tee-fit').offsetHeight;
  let fitDetails = document.querySelector('#tee  #fit .fit-details-list');
  fitDetails.style.height = setHeight + 'px';
};

var lintrollerTech = function () {
  var scrollTop = window.scrollY;
  var specsWrapper = document.querySelector('.tech-specs-placeholder');
  var graphicWrapper = document.querySelector('.tech-specs-graphic-wrapper');
  var posYStart = specsWrapper.offsetTop - window.innerHeight/2 + graphicWrapper.offsetHeight/2;
  var posYMid = specsWrapper.offsetTop + specsWrapper.offsetHeight/2  - graphicWrapper.offsetHeight;
  var posYEnd = specsWrapper.offsetTop + specsWrapper.offsetHeight - window.innerHeight/2 - graphicWrapper.offsetHeight/2;
  var scrollOffset = 0;

  var roller = document.querySelector('.roller');
  var rollerSheet = document.querySelector('.roller-sheet');
  var bluePrint = document.querySelector('.blue-print');
  var ballMechanics = document.querySelector('.ball-mechanics');
  var outerSpecsText = document.querySelector('.specifications .outer');
  var innerSpecsText = document.querySelector('.specifications .inner');

  if ( scrollTop > posYStart && scrollTop < posYEnd) {
    if ( scrollTop < posYMid) {
      ballMechanics.style.display = 'none';
      bluePrint.style.display = 'block';
      rollerSheet.classList.remove('slide-out');
      outerSpecsText.classList.remove('out-of-sight');
      innerSpecsText.classList.add('out-of-sight');
    }
    if ( scrollTop > posYMid) {
      ballMechanics.style.display = 'block';
      bluePrint.style.display = 'none';
      rollerSheet.classList.add('slide-out');
      outerSpecsText.classList.add('out-of-sight');
      innerSpecsText.classList.remove('out-of-sight');
    }
  }
  else {
    bluePrint.style.dislay = 'none';
  }

}

var hammoFitLayout = function () {
  var shotWrapper = $('#hammo-og #hammo-fit .shot-wrapper');
  var fitContents = $('#hammo-og #hammo-fit .fit-contents');
  var setHeight = $('#hammo-og #hammo-fit .fit-contents').outerHeight();
  var setPos = shotWrapper.width() + parseInt( $('#hammo-og-fit .wrapper').css('padding-top') )
  if ( $(window).height() > $(window).width() ){
    shotWrapper.height(setHeight);
    fitContents.css('top', setPos );
  }
  else{
    shotWrapper.height(0);
    fitContents.css('top', '50%' );
  }
};

var initParallax = function () { //Initiate Unit PQ Parallax
  if (typeof Rellax === 'function' && document.querySelector(".parallax")) {
    var parallax = new Rellax('.parallax', {
      breakpoints: [480, 768, 1440]
    });
  }
}

var storiesGrid = function () { //Initiate Masonary for Stories
  setTimeout(function () {
    let msnry = new Masonry('.product #stories', {
      itemSelector: '.grid-item'
    });
  }, 2000);
}

var getComponent = function (productType) {
  return document.querySelector(`${productType}-features`);
}

var setCartMenuHeight = function () {
  if (cartMenu){
    cartMenu.style.height = window.innerHeight;
  }
}

function setShopUrl() {
  // When the page is loaded, we need to set the selected state to the swatch that matches the shop_url.url
  // This is to ensure that the swatch is selected when the page is loaded
  if (typeof(shop_url) !== 'undefined' && shop_url) {
    var swatches;
    if(typeof(renderPack) !== 'undefined' && renderPack){
      swatches = document.querySelectorAll(".packswatches .colours-packs .grid a");
    }
    else{
      swatches = document.querySelectorAll(".swatches a");
    }
    var isSwatchSelected = false;
    var drawerSwatchList = document.querySelectorAll('product-swatch-list .swatch-link');
    for (let i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      let dataUrl = swatch.getAttribute('data-url');
      if (dataUrl == shop_url.url) {
        swatch.classList.add("selected");
        swatch.dispatchEvent(new CustomEvent('click', {
          detail: {
            skipPushState: true
          }
        }));
        isSwatchSelected = true;
        break;
      }
    }
  }   
}
function attachEventListeners() {
  // Add all event listeners here
  let sectionLink = UI.find('.product-nav a.section-link');
  if (sectionLink) {
    sectionLink.addEventListener('click', function (e) {
      if (document.documentElement["clientWidth"] < 768) {
        e.preventDefault();
        toggleProductJumpLink();
      } else {
        return true;
      }
    });
  }
  let nav = UI.find('product-nav');
  if (nav) {
    // Handle Product nav bar click event
    nav.addEventListener('NavbarClick', function (event) {
      let link = event.detail.link, e = event.detail.e;
      let url = `${window.location.origin}${link.getAttribute('data-url')}`;
      resetProductNavLinks();
      link.classList.add('selected');
      //jumpToAnchor(link, e);
      window.history.pushState({ page: url }, "", url);
      stickProductNav();
    });

    // Handle Product swatch click event
    nav.addEventListener('SwatchClick', function (event) {
      event.preventDefault();
      let link = event.detail.link, e = event.detail.e;
      if(!link){
        return;
      }
      let skipPushState = e && e.detail ? e.detail.skipPushState : false;
      let url = `${window.location.origin}${link.getAttribute('data-url')}`;
      resetProductNavLinks();
      link.classList.add('selected');
      let heroSection = UI.find('.product #hero');
      let blockSwatches = UI.find('#block-swatches');
      if (heroSection && blockSwatches === null ) {
        var navPos = heroSection.offsetHeight;
        if (window.scrollY > navPos) {
          //jumpToAnchor(link, e);
        }
      }
      if (!skipPushState && event.detail.storeState) {
        // pushState is pushed on initial page load
        window.history.pushState({ page: url }, "", url);
      }
      stickProductNav();
    });

  }

  let jumpLinks = UI.findAll('.product-nav-wrapper .jump-links-dropdown a');
  if (jumpLinks) {
    for (var i = 0; i < jumpLinks.length; i++) {
      jumpLinks[i].addEventListener('click', function (e) {
        mainUI.productJumpLink.classList.add('out-of-sight-y');
      });
    }
  }
  
  let moreColorsLinks = UI.findAll('.product-nav-wrapper .swatches .more-colours');
  if (moreColorsLinks) {
    for (var i = 0; i < moreColorsLinks.length; i++) {
      moreColorsLinks[i].addEventListener('click', function (e) {
        event.preventDefault();
        showSwatchNav();
      });
    }
  }
  
  /*mock function to close swatch menu*/
  let swatchListMenu = UI.find('#swatchList');
  if (swatchListMenu) {
    swatchListMenu.addEventListener('click', function (e) {
      event.preventDefault();
      hideSwatchNav();
    });
  }
  
  let subscribeLinks = UI.findAll('.subscribe-modal-link');
  if (subscribeLinks) {
    for (var i = 0; i < subscribeLinks.length; i++) {
      subscribeLinks[i].addEventListener('click', function (e) {
        event.preventDefault();
        UI.showModal('subscribeForm');
      });
    }
  }
}
function onchangeProductCollectionSwatch(){
  let ProductCollectionSwatches = UI.findAll('main.product-collection div.swatch');
  if (ProductCollectionSwatches){
    for(const swatch of ProductCollectionSwatches){
        swatch.addEventListener('click', function(event){
        event.stopPropagation();
        event.preventDefault();
        let imgUrl = swatch.getAttribute('data-imgRef');
        let parent = swatch.closest('.category-product')
        let image = parent.querySelector('div.image-wrapper img');
        image.src = imgUrl;
      });
    }
  }
}

window.addEventListener('DOMContentLoaded', function () { //OnLoad Events
  attachEventListeners();
  stickProductNav();
  //stickDetailsBlock();
  setCartMenuHeight();
  setShopUrl();
  //sliderIndicator();
  //sliderInitialPos();
  //setBlockHeight();

  // Initiate LazyLoad
  if ( mainUI.body.classList.contains('product-page') && UI.find('#mask') ) {
    lazyLoadInstance = new LazyLoad();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#tee #fit') ) {
    setTeeFitLayout();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#unitpq #features')){
    initParallax();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#stories') ) {
    storiesGrid();
  }
  if ( mainUI.body.classList.contains('product-index') && UI.find('#home') ) {
    //animTimer();
  }
  // if( mainUI.body.classList.contains('product-page') && UI.find('#hammo-og') ) {
  //   hammoFitLayout();
  // }
  // if( mainUI.body.classList.contains('product-variant') && UI.find('#mug-special') ) {
  //   const arElement = document.querySelector('.product-variant #hero .ghost-image');
  //   const arEnabled = detectiOSARQuickLook();
  //   arElement.style.display = arEnabled ? "block" : "none";
  // }
  onchangeProductCollectionSwatch();
});

window.addEventListener('scroll', function () { //Scroll Events
  stickProductNav();
  stickDetailsBlock();
  //hideScrollIndicator();
  if( mainUI.body.classList.contains('product-page') && UI.find('#lintroller') ) {
    lintrollerTech();
  }
});

window.addEventListener('resize', function () { //Resize Events
  setCartMenuHeight();
  stickDetailsBlock();
  //setBlockHeight();

  // Initiate LazyLoad
  if ( mainUI.body.classList.contains('product-page') && UI.find('#mask') ) {
    lazyLoadInstance = new LazyLoad();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#tee #fit') ) {
    setTeeFitLayout();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#unitpq #features')){
    initParallax();
  }
  if ( mainUI.body.classList.contains('product-page') && UI.find('#stories') ) {
    storiesGrid();
  }
  // if( mainUI.body.classList.contains('product-page') && UI.find('#hammo-og') ) {
  //   hammoFitLayout();
  // }
});
